export enum internalProcessStatusText {
    // 1 => Novo, 2 => Em Andamento, 3 => Arquivado, 4 => Concluído'
    NOVO = 'Novo',
    EM_ANDAMENTO = 'Em Andamento',
    ARQUIVADO = 'Arquivado',
    CONCLUIDO = 'Concluído',
    CORRECAO = 'Correção',
    RESPONDIDO = 'Respondido',
    VENCIDO = 'Vencido',
    ANULADO = 'Anulado',
    EM_TRIAGEM = 'Em Triagem',
    INSTAURADO = 'Instaurado',
    INTIMADO = 'Intimado',
    EM_ANALISE_DEFESA = 'Em Análise da Defesa',
    PENDENTE = 'Pendente',
    ARQUIVADO_SEM_ANALISE = 'Arquivado sem análise'
}

export enum internalProcessStatusEnum {
    // 1 => Novo, 2 => Em Andamento (3 => Arquivado, 4 => Concluído, => 5 TRAMITADO)'
    NOVO = 1,
    EM_ANDAMENTO = 2,
    ARQUIVADO = 3,
    CONCLUIDO = 4,
    CORRECAO = 6,
    RESPONDIDO = 7,
    VENCIDO = 8,
    ANULADO = 9,
    EM_TRIAGEM = 10,
    INSTAURADO = 11,
    INTIMADO = 12,
    EM_ANALISE_DEFESA = 13,
    PENDENTE = 15,
    ARQUIVADO_SEM_ANALISE = 16
}

/** "Arquivado" é o arquivamento manual; "Arquivado sem análise", o automático por falta de resposta na correção. */
export const internalProcessArchivedStatuses: readonly internalProcessStatusEnum[] = [
    internalProcessStatusEnum.ARQUIVADO,
    internalProcessStatusEnum.ARQUIVADO_SEM_ANALISE,
];

export enum internalProcessCorrectionStatus {
    EM_CORRECAO = 0,
    CORRIGIDO = 1
}

export enum internalProcessGeneratesDocumentsName {
    INTERNAL_PROCESS = "internalProcess",
    DOCUMENT_OF_PROCESS = "documentosDoProcesso",
}